<div style="margin-top: 10px;">
  <form [formGroup]="consortiumListForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row" style="margin-top: 20px;">
          @if (addPermission) {
            <a class="__add_client" (click)="openConsortiumForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Consortium
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <div class="table-scroll-container">
            <table mat-table matSort [dataSource]="consortiumDataSource">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Consortium Name</span>
                    <input placeholder="Search..." type="search" matInput
                      autocomplete="off" formControlName="name" class="mat-input-custom">
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.name}}</td>
                </ng-container>
                <ng-container matColumnDef="lineNames">
                  <th mat-header-cell *matHeaderCellDef class="header">
                    <div class="sorting_header">
                      <span mat-sort-header>Line</span>
                      <input placeholder="Search..." type="search" matInput
                        autocomplete="off" formControlName="lineName" class="mat-input-custom">
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.lineNames}}</td>
                  </ng-container>
                  <ng-container matColumnDef="destinationNames">
                    <th mat-header-cell *matHeaderCellDef class="header">
                      <div class="sorting_header">
                        <span mat-sort-header>Destination</span>
                        <input placeholder="Search..." type="search" matInput
                          autocomplete="off" formControlName="destinationName" class="mat-input-custom">
                        </div>
                      </th>
                      <td mat-cell *matCellDef="let element">{{element.destinationNames}}</td>
                    </ng-container>
                    <ng-container matColumnDef="vesselNames">
                      <th mat-header-cell *matHeaderCellDef class="header">
                        <div class="sorting_header">
                          <span mat-sort-header>Vessel</span>
                          <input placeholder="Search..." type="search" matInput
                            autocomplete="off" formControlName="vesselName" class="mat-input-custom">
                          </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.vesselNames}}</td>
                      </ng-container>
                      <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="header">
                          <div class="sorting_header">
                            <span mat-sort-header>Status</span>
                            <mat-select formControlName="status" placeholder="Search...">
                              @for (status of statusTypes; track status) {
                                <mat-option [value]="status.key">
                                  {{status.label}}
                                </mat-option>
                              }
                            </mat-select>
                          </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.status}}</td>
                      </ng-container>
                      <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>
                          <span class="mat-sort-header-content" >Action</span></th>
                          <td class="__action_row" mat-cell *matCellDef="let element">
                            <span class="__action_edit_icon" (click)="openConsortiumForm(element.id)" style="margin-right: 10px;">
                              <mat-icon>create</mat-icon>
                            </span>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="consortiumColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: consortiumColumns;"></tr>
                      </table>
                    </div>
                  }
                </mat-card-content>
              </mat-card>
              @if (viewPermission) {
                <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="totalRecords" showFirstLastButtons></mat-paginator>
              }
            </form>
          </div>



